import React from "react";
import { func } from "prop-types";
import moment from "moment";
import { FaLayerGroup } from "react-icons/fa";
import ReactTooltip from "react-tooltip";
import { logType } from "../../../../../prop-types/logTypes";
import { VscWarning } from "react-icons/vsc";
import { IoIosInformationCircleOutline } from "react-icons/io";
import { VscError } from "react-icons/vsc";
import { AiOutlineSetting } from "react-icons/ai";

const LogsTableRow = ({ log, toggleDetails }) => (
  <React.Fragment>
    <tr className="logs-tr">
      <td className="pl-4">{log.action}</td>
      <td className="pl-0"> {log.createdByUserName}</td>
      <td className="w-5 pt-0 pb-0 text-center">
        <RenderIcon type={log.type} />
      </td>
      <td className=" logs-date-tr">
        {moment.utc(log.createDate).local().format("DD-MM-YYYY HH:mm:ss")}
      </td>
      <td className="text-center pt-0 pb-0">
        <ReactTooltip id="details-icon" type="info">
          <span>Details</span>
        </ReactTooltip>
        <FaLayerGroup
          size="1.3em"
          data-tip
          data-for="details-icon"
          color="cornflowerblue"
          onClick={() => toggleDetails(log.message)}
        />
      </td>
    </tr>
  </React.Fragment>
);

function RenderIcon({ type }) {
  switch (type) {
    case 1:
      return (
        <IoIosInformationCircleOutline
          style={{ cursor: "auto" }}
          color="#0088E4"
          size={25}
        />
      );
    case 2:
      return (
        <VscWarning color="#FCB925" style={{ cursor: "auto" }} size={25} />
      );
    case 3:
      return <VscError color="#FF0000" style={{ cursor: "auto" }} size={25} />;
    case 4:
      return (
        <AiOutlineSetting
          color="#000000"
          style={{ cursor: "auto" }}
          size={25}
        />
      );
    default:
      return <p>...</p>;
  }
}
LogsTableRow.propTypes = {
  log: logType,
  toggleDetails: func.isRequired,
};

export default LogsTableRow;



// WEBPACK FOOTER //
// ./src/features/log/components/logs-table/logs-table-row/LogsTableRow.jsx